import {
    createStore, combineReducers, applyMiddleware, compose,
} from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

const middlewares = [thunk];

const isDev = process.env.NODE_ENV === 'development';

const composeEnhancers = ((typeof window !== 'undefined' && isDev)
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
    combineReducers({
        ...reducers,
    }),
    composeEnhancers(applyMiddleware(...middlewares)),
);

export { store };
